export const setLoader = data => ({
  type: "SET_LOADER",
  payload: data,
});

export const setAddAddressModal = data => ({
  type: "SET_ADD_ADDRESS_MODAL",
  payload: data,
});

export const setDeleteAddressModal = data => ({
  type: "SET_DELETE_ADDRESS_MODAL",
  payload: data,
});

export const setEditAddressModal = data => ({
  type: "SET_EDIT_ADDRESS_MODAL",
  payload: data,
});

export const setContactUsResponse = data => ({
  type: "SET_CONTACT_US_RESPONSE",
  payload: data,
});

export const setContactUsObject = data => ({
  type: "SET_CONTACT_US_OBJECT",
  payload: data,
});

// const rootURL = "https://pndapi.drycleandepotdelivers.com/";

export const postContactUs = viewModel => {
  return async function (dispatch) {
    return await postData(`${process.env.REACT_APP_DEV_PYTHON_URL}/faqs/complaint/`, viewModel)
      .then(data => {
        dispatch(setContactUsResponse(data));
      })
      .catch(error => {
        console.error(error);
      });
  };
};

export const fetchContactUs = token => {
  return async function (dispatch) {
    return await fetch(`${process.env.REACT_APP_DEV_PYTHON_URL}/order/franchise-info/?franchise_id=1`, {
      method: "GET",
      mode: "cors",
      headers: new Headers({
        Accept: "application/json, text/plain, */*",
        Authorization: "Token " + token,
        "Content-Type": "application/json",
      }),
    })
      .then(res => res.json())
      .then(
        result => {
          dispatch(setContactUsObject(result));
        },
        error => {
          console.error(error);
        }
      );
  };
};

const postData = async (url = "", data = {}) => {
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, */*",
      Authorization: 'Token ' + localStorage.getItem("Token"),
    },
    body: JSON.stringify(data),
  });
  return response.json(); // parses JSON response into native JavaScript objects
};
